import { render, staticRenderFns } from "./LogoCryptotaskOrg.vue?vue&type=template&id=328d7410&scoped=true&"
import script from "./LogoCryptotaskOrg.vue?vue&type=script&lang=js&"
export * from "./LogoCryptotaskOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328d7410",
  null
  
)

export default component.exports